<template>
  <div class="body">
    <el-card>
      <el-form ref="form" :model="form" label-width="80px" @submit.native.prevent  class="operationControl">
        <el-row>
          <el-col :span="6">
            <el-form-item label="试题编号" prop="questionNo">
              <el-input v-model="form.questionNo" @keyup.enter.native="searchQuestionBankList"  clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="目录" prop="directoryId">
              <selectTree
                :props="{
                  value: 'id', // ID字段名
                  label: 'directoryName', // 显示名称
                  children: 'directoryList' // 子级字段名
                }"
                clearable
                :options="catalogList"
                :value="form.directoryId"
                @getValue="directoryChange"
              ></selectTree>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="难度" prop="questionDifficulty">
              <el-select v-model="form.questionDifficulty" placeholder="请选择">
                <el-option label="0" value="0"></el-option>
                <el-option label="1" value="1"></el-option>
                <el-option label="2" value="2"></el-option>
                <el-option label="3" value="3"></el-option>
                <el-option label="4" value="4"></el-option>
                <el-option label="5" value="5"></el-option>
                <el-option label="6" value="6"></el-option>
                <el-option label="7" value="7"></el-option>
                <el-option label="8" value="8"></el-option>
                <el-option label="9" value="9"></el-option>
                <el-option label="10" value="10"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="6">
            <el-form-item label="创建者" prop="createdBy">
              <el-input v-model="form.createdBy"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="创建时间" prop="date">
              <el-date-picker
                v-model="form.date"
                type="daterange"
                value-format="timestamp"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="题型" prop="questionType">
              <el-select v-model="form.questionType" placeholder="请选择">
                <el-option
                  v-for="(item, index) in questionTypeList"
                  :key="index"
                  :label="item.text"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <div class="searchBut">
              <el-form-item>
                <el-button @click="searchQuestionBankList" type="primary"
                >搜索
                </el-button
                >
                <el-button @click="resetForm('form')">重置</el-button>

                <el-button
                  type="primary"
                  icon="el-icon-plus"
                  @click="$router.push('/mall/examination/addQuestion?type=edit')"
                >新建
                </el-button
                >
                <el-button @click="showImportVisible" type="primary"
                >导入

                </el-button
                >
                <el-button @click="exportVisible = true" type="primary"
                >导出
                </el-button
                >
              </el-form-item>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        :data="questionBankList"
        tooltip-effect="dark"
        style="width: 100%"
        v-loading="tableLoading" element-loading-text="拼命加载中"
        height="516"
      >
        <el-table-column
          label="试题编号"
          prop="questionNo"
          width="150"

        ></el-table-column>
        <el-table-column label="题型" width="150px">
          <template slot-scope="scope">{{
              scope.row.questionType == 1
                ? "单选题"
                : scope.row.questionType == 2
                ? "多选题"
                : scope.row.questionType == 3
                  ? "判断题"
                  : ""
            }}
          </template>
        </el-table-column>
        <el-table-column label="试题" >
          <template slot-scope="scope">
            <div class="pre" v-html="scope.row.questionStemContent"></div>
            <!-- <p>{{ scope.row.questionStemContent }}</p>
            <p style="color:#999;">
              分数:{{ scope.row.score }} 编号:{{ scope.row.questionNo }}
            </p> -->
          </template>
        </el-table-column>
        <el-table-column
          label="所属目录"
          prop="directoryName"
          width="150px"
        ></el-table-column>
        <el-table-column
          label="难度"
          prop="questionDifficulty"
          width="50"
        >

        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="createdTime"
          width="200"
        ></el-table-column>

<!--        <el-table-column label="状态" width="150px">-->
<!--          <template slot-scope="scope">-->
<!--            <span v-if="scope.row.questionStatus == 0" type="success"-->
<!--            >正常-->
<!--            </span>-->
<!--            <span v-else type="warning">不正常</span>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="success"
              @click="
                $router.push(
                  `/mall/examination/detailQuestion?type=check&id=${scope.row.id}`
                )
              "
            >查看
            </el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="
                $router.push(
                  `/mall/examination/updateQuestion?type=edit&id=${scope.row.id}`
                )
              "
            >编辑
            </el-button
            >

            <el-button
              size="mini"
              type="danger"
              @click="delLibrary(scope.row.id)"
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:20px; float:right;"
        @size-change="sizeChange"
        :current-page="page"
        @current-change="pageChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>

      <el-dialog title="试题导入" :visible.sync="importVisible" width="70%" @close="importClose">
        <div style="padding:20px 50px;">
          <el-steps :active="step" simple class="mb20">
            <el-step title="选择导入模板"></el-step>
            <el-step title="确认数据源"></el-step>
          </el-steps>

          <el-form ref="importForm" label-width="120px">
            <div v-show="step == 1">
              <el-row>
                <el-col :span="6">
                  <el-form-item label="下载导入模板" prop="questionNo">
                    <el-button size="mini" type="primary" @click="downExcel"
                    >Excel模板
                    </el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="导入到目录" prop="questionNo">
                    <selectTree
                      ref="selectTree1443"
                      :props="{
                      value: 'id', // ID字段名
                      label: 'directoryName', // 显示名称
                      children: 'directoryList' // 子级字段名
                    }"
                      :options="catalogList"
                      @getValue="importSelectTreeChange"
                    ></selectTree>
                    <!-- <el-select v-model="directoryIndex" placeholder="请选择">
                      <el-option
                        v-for="(item, index) in catalogList"
                        :key="index"
                        :label="item.directoryName"
                        :value="index"
                      ></el-option>
                    </el-select> -->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="uploadData.questionsDirectoryId">
                <el-col :span="6">
                  <el-form-item label="选择导入文件" prop="questionNo">
                    <el-upload
                      :action="uploadUrl"
                      :headers="headers"
                      :on-success="uploadSuccess"
                      :data="uploadData"
                      :accept="'.xlsx,.xls'"
                      :file-list="importFileList">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="importFile(scope.$index)"
                      >导入
                      </el-button
                      >
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div v-show="step == 2" class="f-c-c">
              <el-table class="mb20" :data="successList" style="60vw">
                <el-table-column
                  prop="questionNo"
                  label="试题编号"
                ></el-table-column>
                <el-table-column
                  prop="context"
                  label="试题内容"
                ></el-table-column>
                <el-table-column prop="answer" label="答案"></el-table-column>
                <el-table-column prop="questionType" label="题型">
                  <template slot-scope="scope">{{
                      scope.row.questionType == 1
                        ? "单选题"
                        : scope.row.questionType == 2
                        ? "多选题"
                        : scope.row.questionType == 3
                          ? "判断题"
                          : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column prop="questionDifficulty" label="试题难度"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="danger"
                      @click="successList.splice(scope.$index, 1)"
                    >删除
                    </el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form>
        </div>
        <div slot="footer" v-if="step == 2" class="f-b-c" style="padding:0 30px;">
          <span></span>
          <div>
            <!-- <el-button type="primary" @click="--step">上一步</el-button> -->
            <el-button type="primary" @click="importDate">导入数据</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="试题导出"
        :visible.sync="exportVisible"
        width="50%"
        @close="closeExport"
      >
        <el-form ref="importForm" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="目录" prop="questionNo">
                <selectTree
                  :props="{
                  value: 'id', // ID字段名
                  label: 'directoryName', // 显示名称
                  children: 'directoryList' // 子级字段名
                }"
                  :options="catalogList"
                  @getValue="exportSelectTreeChange"
                ></selectTree>
                <!-- <el-select v-model="directoryIndex2" placeholder="请选择">
                  <el-option
                    v-for="(item, index) in catalogList"
                    :key="index"
                    :label="item.directoryName"
                    :value="index"
                  ></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="导出">
                <el-button type="primary" @click="exportFile">导出</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
/**
 questionType:题型
 questionNo:试题编号
 questionStatus:试题状态
 questionDifficulty:试题难度
 createdBy:创建者
 startCreateTime:开始时间
 endCreateTime:结束时间
 */
import selectTree from "@/components/common/selectTree";
import api from "@/api/mall/exam.js";

export default {
  components: {selectTree},
  data() {
    return {
      form: {
        questionType: undefined,
        questionNo: undefined,
        questionStatus: undefined,
        questionDifficulty: undefined,
        createdBy: undefined,
        startCreateTime: undefined,
        endCreateTime: undefined,
        directoryId: undefined,
      },
      questionTypeList: [], // 题型列表
      questionBankList: [], // 题库列表
      selectQuestionBankList: [],
      page: 1,
      pageSize: 10,
      total: 0, // 总条数
      catalogList: [],
      exportCatalog: {},
      step: 1,
      importVisible: false,
      exportVisible: false,
      uploadUrl: "",
      headers: {
        Authorization: ""
      },
      uploadData: {
        directoryName: undefined,
        questionsDirectoryId: undefined
      },
      importFileList: [],
      successList: [],
      directoryIndex2: undefined,
      exportForm: {
        directoryName: undefined,
        questionsDirectoryId: undefined
      },

      tableLoading: undefined
    };
  },
  mounted() {
    this.questionTypeList = JSON.parse(
      localStorage.getItem("questionTypeList")
    );
    this.getQuestionBankList();
    this.getCatalogList();

    this.uploadUrl =
      process.env.API_ROOT + "/mall/m/training/library/checkExcel";
    this.headers.Authorization = window.localStorage.getItem("access-token");
  },
  methods: {
    showImportVisible(){
      this.importVisible = true;
      console.log('sleect 1 %o', this.$refs.selectTree1443)
      this.$refs.selectTree1443.clearSelected();
    },
    directoryChange(e) {
      this.form.directoryId = e.id;
    },
    closeExport() {
      this.step = 1;
    },
    exportSelectTreeChange(e) {
      this.exportCatalog = e;
    },
    importSelectTreeChange(e) {
      this.uploadData = {
        directoryName: e.text,
        questionsDirectoryId: e.id
      };
    },
    getCatalogList() {
      api
        .getCatalogList({
          type: 1,
          // enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
          //   .enterpriseId
        })
        .then(res => {
          this.catalogList = res.data;
        });
    },
    exportFile() {
      if (!this.exportCatalog.id) return this.$message.error("请选择目录");
      api
        .exportExcel({
          directoryName: this.exportCatalog.text,
          questionsDirectoryId: this.exportCatalog.id
        })
        .then(res => {
          console.log(res);
          let blob = new Blob([res]);
          let a = document.createElement("a");
          a.download = "导出题目.xls";
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        })
        .catch(e => {
          this.$message.error("此目录没题目,不允许导出！");
        });
    },
    downExcel() {
      window.open(`${location.origin}/static/题库上传.xlsx`);
    },
    importDate() {
      api.importData({
        sussceList: this.successList,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
        //   .enterpriseId
      })
        .then(res => {
          if (res.code == 0) {
            console.log(res,'res')
            this.$message.success("导入数据成功");
            this.importVisible = false;
            --this.step;
            this.successList = [];
            this.$refs.selectTree1443.clearHandle();
            this.getQuestionBankList();
          } else {
            this.$message.error("导入数据失败");
          }
        });
    },
    uploadSuccess(e) {
      if (!e.data.sussceList || e.data.sussceList < 1) {
        if (e.data.errorList && e.data.errorList.length > 0) {
          this.$message.error(e.data.errorList.join(''));
        } else {
          this.$message.error("文件格式错误，无法进行解析");
        }
        this.importFileList = [];
        return;
      }
      if(e.data.errorList.length >0 || e.data.errorList  == null) {
        // setTimeout(() => {
        this.$message.error(e.data.errorList.join(''));

        // }, 1000);
      }else {
        this.$message.success("导入文件成功");
        this.successList = e.data.sussceList;
        ++this.step;
      }
      // if (!e.data.sussceList || e.data.sussceList < 1) {
      //   if (e.data.errorList && e.data.errorList.length > 0) {
      //     this.$message.error(e.data.errorList.join(''));
      //   } else {
      //     this.$message.error("文件格式错误，无法进行解析");
      //   }
      //   this.importFileList = [];
      //   return;
      // }
      // this.$message.success("导入文件成功");
      // this.successList = e.data.sussceList;
      // ++this.step;
    },
    delLibrary(questionId) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          api.delLibrary({questionId}).then(res => {
            if (res.code == 0) {
              this.$message.success("成功");
              this.getQuestionBankList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
        this.searchQuestionBankList();
      });
    },
    searchQuestionBankList(){
      this.page =  1;
      this.getQuestionBankList();
    },
    //题库列表
    getQuestionBankList() {
      let p = {
        ...this.form,
        page: this.page,
        pageSize: this.pageSize,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };

      if (p.date && p.date.length > 0) {
        p.startCreateTime = p.date[0];
        p.endCreateTime = p.date[1];
      }

      if (!p.directoryId) {
        delete p.directoryId;
      }
      delete p.date;

      this.tableLoading = true;
      api.getQuestionBankList(p).then(res => {
        this.questionBankList = res.data.records;
        this.total = res.data.total;
        this.tableLoading = false;
      });
    },
    sizeChange(e){
      this.pageSize = e;
      this.getQuestionBankList();
    },
    pageChange(e) {
      this.page = e;
      this.getQuestionBankList();
    },
    //题库导出
    libraryExportQuestion() {
      api.libraryExportQuestion().then(res => {
        if (res.code == 0) {
          console.log(res);
          // this.$message.success("成功");
          // this.getQuestionBankList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    /**
     *导入关闭
     */
    importClose() {
      this.step = 1;
      this.uploadData = [];
      this.successList = [];
      this.importFileList = [];

    }
  },
  watch: {
    directoryIndex2(v) {
      this.exportForm = {
        directoryName: this.catalogList[v].directoryName,
        questionsDirectoryId: this.catalogList[v].id
      };
    }
  }
};
</script>

<style>
.pre img {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/examination/questionBankManagenment.vue